import { aroApiSlice } from './apiSlice';
import { getBaseURL } from '../../../utilities/config';

// To Do: use baseURL and remove full url from query
export const manufacturingApiSlice = aroApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getManufacturing: builder.query({
            query: () => `${getBaseURL()}/manufacturing`,
        }),
    }),
});

export const { useGetManufacturingQuery } = manufacturingApiSlice;
